// extracted by mini-css-extract-plugin
export var backgroundMediaWrapper = "basicHero-module--background-media-wrapper--1bc79";
export var baseline = "basicHero-module--baseline--10336";
export var basicHero = "basicHero-module--basic-hero--5ed42";
export var content = "basicHero-module--content--a8b95";
export var desktopImage = "basicHero-module--desktop-image--4a670";
export var float = "basicHero-module--float--b4635";
export var image = "basicHero-module--image--cc191";
export var mobileImage = "basicHero-module--mobile-image--6112e";
export var overlay = "basicHero-module--overlay--d1118";
export var videoControl = "basicHero-module--video-control--20134";